import { useState, useEffect } from 'react';
import { useGetCurrentUserProfile } from './use-get-current-user-profile.hook';
import { avatarOptions } from '../constants/avatar-options';

const defaultAvatar = avatarOptions[0];

export const useAvatar = () => {
  const [avatar, setAvatar] = useState(defaultAvatar);
  const [isLoading, setIsLoading] = useState(true);
  const { userProfile } = useGetCurrentUserProfile();

  useEffect(() => {
    if (!userProfile) {
      setIsLoading(true);
      return;
    }

    setIsLoading(true);
    const avatarId = userProfile.avatar;
    const avatarObject =
      avatarOptions.find((option) => option.id === avatarId) || defaultAvatar;
    setAvatar(avatarObject);
    setIsLoading(false);
  }, [userProfile]);

  return { avatar, isLoading };
};
